<template>
  <div class="popup__img">
    <slot />
  </div>
</template>
